import {ChangeDetectorRef, Component, EventEmitter, Input, Output,} from '@angular/core';
import {Geolocation} from "@capacitor/geolocation";
import {Point} from "typeorm"
@Component({
  selector: 'app-gps',
  templateUrl: './gps.component.html',
  styleUrls: ['./gps.component.scss'],
})
export class GpsComponent {
  _ligado =false
  accuracy = 0
  @Input()
  point?: Point

  constructor(private cdr: ChangeDetectorRef) {
  }

  @Output()
  pointChange = new EventEmitter<Point>();

  get ligado(): boolean{return this._ligado}

  @Input()
  set ligado(value: boolean){
    this._ligado = value
    if(value) this.ligarGPS().then()
  }

    async ligarGPS(){
      await Geolocation.watchPosition({
        enableHighAccuracy: true
      }, (position, err) => {
        const coords = position?.coords
        this.point = {
          type: "Point",
          coordinates: [coords?.longitude!!, coords?.latitude!!]
        }
        this.accuracy = coords?.accuracy||0
        this.cdr.detectChanges()
        this.pointChange.emit(this.point)
      })
    }

}
